import "./HeroPanel.css";

function HeroPanel({ eyebrow, title, text, ctaLabel, ctaHref }) {
  return (
    <section className="hero-panel-container hover-lift">
      <div className="hero-panel-inner">
        <div className="hero-panel-content">
          {eyebrow && <span className="eyebrow">{eyebrow}</span>}
          
          <h1>{title}</h1>
          <p>{text}</p>
          
          {ctaLabel && (
            <div className="cta-group">
              <a href={ctaHref || "/contact"} className="btn">
                {ctaLabel}
              </a>
              <span className="no-jobs-label">
                Keine Bewerbungen für Arbeit / No Applications for jobs
                <br/>
                Wir arbeiten nicht mit Subunternehmern.
              </span>
            </div>
          )}

          <a href="tel:081716971" className="hero-panel-call-min">
            Kunden-Telefon: <span>08171 6971</span>
          </a>
        </div>

        <div className="hero-panel-visual" aria-hidden="true" fetchpriority="high" />
      </div>
    </section>
  );
}

export default HeroPanel;